import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 56px);
  background: ${(props) => props.theme.$gray100};
  line-height: normal;

  .tool-not-found {
    flex: 1;
    padding: 48px 16px;
  }

  .tool-main {
    display: flex;
    flex: 1;
    justify-content: center;
    min-width: 0;
    padding: 29px 56px 40px;
  }

  /* Título, vídeo e descrição formam uma coluna centralizada na área cinza. A
     largura acompanha a altura da janela para o vídeo caber sem rolagem. */
  .tool-content {
    width: 100%;
    max-width: max(480px, min(1040px, calc((100vh - 286px) * 16 / 9)));
  }

  .tool-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;

    h1 {
      margin: 0;
      color: ${(props) => props.theme.$gray900};
      font-size: 24px;
      font-weight: 600;
      line-height: normal;
    }
  }

  .tool-video {
    margin-top: 14px;
    overflow: hidden;
    border-radius: 14px;
  }

  .tool-video-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    aspect-ratio: 16 / 9;
    background: #d9d9d9;
    color: ${(props) => props.theme.$gray700};
    font-size: 14px;

    .material-icons {
      font-size: 48px;
    }
  }

  .tool-description {
    margin: 32px 0 0;
    color: ${(props) => props.theme.$gray900};
    font-size: 16px;
    white-space: pre-line;
  }

  .tool-steps {
    display: flex;
    flex: 0 0 clamp(407px, 30%, 560px);
    flex-direction: column;
    justify-content: space-between;
    gap: 32px;
    padding: 20px 20px 40px;
    border-top: 1px solid ${(props) => props.theme.$gray400};
    background: ${(props) => props.theme.$white};

    ol {
      width: 100%;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 8px;
      padding: 28px 18px 20px;
      border-top: 1px solid #f0f0f0;
      color: ${(props) => props.theme.$gray800};

      &:first-child {
        margin-top: 0;
        padding-top: 20px;
        border-top: 0;
      }
    }

    /* Tamanhos e pesos da plataforma (Roboto 400/700), como na área do embaixador. */
    .step-number {
      color: #10a875;
      font-size: 14px;
      font-weight: 700;
    }

    .step-title {
      font-size: 16px;
      font-weight: 700;
    }

    li p {
      margin: 0;
      color: ${(props) => props.theme.$gray600};
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5;
    }
  }

  .tool-start {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }

  .tool-start-hint {
    margin: 0;
    color: ${(props) => props.theme.$gray600};
    font-size: 13px;
    text-align: right;
  }

  .tool-start-error {
    color: ${(props) => props.theme.$danger};
  }

  /* O que falta para liberar o teste, com o "i" vermelho dos cards bloqueados da área. */
  .tool-start-notice {
    display: flex;
    align-self: stretch;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 12px 16px;
    border: 1px solid ${(props) => props.theme.$danger_light_bg_hover};
    border-radius: 8px;
    background: ${(props) => props.theme.$danger_light_bg};
    color: ${(props) => props.theme.$danger_border_strong};
    font-size: 14px;
    font-weight: 700;

    .material-icons {
      flex-shrink: 0;
      font-size: 18px;
    }
  }

  .tool-feedback-link {
    color: #10a875;
    font-weight: 900;
  }

  @media only screen and (max-width: 991px) {
    flex-direction: column;

    .tool-main {
      padding: 24px 16px;
    }

    .tool-content {
      max-width: none;
    }

    .tool-steps {
      flex: none;
      padding: 20px 16px 32px;
    }

    .tool-start {
      align-items: stretch;
    }

    .tool-start-hint {
      text-align: left;
    }
  }
`;
